export default "__VITE_PUBLIC_ASSET__801f19bb__"